import { AxiosProgressEvent, AxiosResponse } from 'axios';

import { FileManagementResponse } from '../../../../types/FileManagementResponse';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';
import { nonEmpty } from '../paramUtils';

export const uploadFile = async (
    file: File,
    offerId: string,
    onUploadProgress: (event: AxiosProgressEvent) => void
): Promise<FileManagementResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await authorizedAxiosInstance.post(`/v1/offer/${offerId}/files`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
    });

    return response.data;
};

export const downloadFile = (fileId: string, offerId: string): Promise<AxiosResponse> => {
    return authorizedAxiosInstance.get(`/v1/offer/${offerId}/files/${fileId}/download`, {
        responseType: 'blob',
    });
};

export const deleteFile = async (fileIds: string[], offerId: string): Promise<void> => {
    await authorizedAxiosInstance.delete(`/v1/offer/${offerId}/files`, {
        params: {
            ids: nonEmpty(fileIds),
        },
    });
};
